import React from 'react';
import { FC } from 'react';
import { Icons } from '@components/Icon';
import { IconTemplate } from '@components/Icon/IconTemplate';
import useTranslations from '@hooks/useTranslation';
import ContentTemplate from '../../ui/Content/Content';
import { Answer, Item, Items, Question } from './ContactQuestions.elements';

export interface ContactQuestionsProps {}

const ContactQuestionsTemplate: FC<ContactQuestionsProps> = () => {
    const { t } = useTranslations();

    return (
        <ContentTemplate sidePadding={20}>
            <Items>
                <Item>
                    <IconTemplate name={Icons.Question1} />
                    <Question>
                        <div dangerouslySetInnerHTML={{ __html: t('contact.question1') }} />
                    </Question>
                    <Answer>
                        <div dangerouslySetInnerHTML={{ __html: t('contact.answer1') }} />
                    </Answer>
                </Item>
                <Item>
                    <IconTemplate name={Icons.Question2} />
                    <Question>
                        <div dangerouslySetInnerHTML={{ __html: t('contact.question2') }} />
                    </Question>
                    <Answer>
                        <div dangerouslySetInnerHTML={{ __html: t('contact.answer2') }} />
                    </Answer>
                </Item>
                <Item>
                    <IconTemplate name={Icons.Question3} />
                    <Question>
                        <div dangerouslySetInnerHTML={{ __html: t('contact.question3') }} />
                    </Question>
                    <Answer>
                        <div dangerouslySetInnerHTML={{ __html: t('contact.answer3') }} />
                    </Answer>
                </Item>
            </Items>
        </ContentTemplate>
    );
};

export default ContactQuestionsTemplate;
